import React from 'react';
import { Card, Col, Row, Typography } from 'antd';

const { Title, Text } = Typography;

const SeccionPersonalizar = () => {
    return (
        <div className="fade-in">
            <Title level={4}>Personalización de Interfaz</Title>
            <Card style={{ borderRadius: 12 }}>
                <Text type="secondary">Selecciona el color de acento:</Text>
                <Row gutter={16} style={{ marginTop: 20 }}>
                    {['#22BABB', '#1890ff', '#722ed1', '#eb2f96', '#faad14'].map(color => (
                        <Col key={color}><div style={{ width: 50, height: 50, borderRadius: '8px', backgroundColor: color, cursor: 'pointer', border: color === '#22BABB' ? '3px solid #000' : 'none' }} /></Col>
                    ))}
                </Row>
            </Card>
        </div>
    );
};

export default SeccionPersonalizar